import React, { useEffect, useState } from "react";
import logo from "../../../../../Assets/Images/Logo.png";
import { useSelector } from "react-redux";
import TempFooter from "./common/TempFooter";
import { printSection } from "./common/enum";

const PrintTempThree = ({
  pageNumber,
  totalPages,
  items,
  isLastPage,
  tableTotal,
  allData,
  taxDetails,
  qrData,
  invoiceDetails,
}) => {
  // const invoiceDetails = {
  //   orderId: "004280726R9095629120",
  //   invoiceNo: "SFOG145568",
  //   companyName: "Deepak Dinesh",
  //   address:
  //     "Leeyat Techno Hub, Gov Cyber park,\nkohylad building, 2nd floor, near hills\nmall, Potlani\nKozhikode, 673016 Kerala",
  //   phone: "XXXXXXXXXX",
  //   invoiceDate: "15-05-2023",
  //   companyNameArabic: "ليات تكنو هاب",
  //   addressArabic:
  //     "ليات تكنو هاب، حديقة جوف سايبر،\nمبنى كوهيلاد، الطابق الثاني، بالقرب من هيلز\nمول، بوتلاني\nكوزيكود، 673016 كيرالا",
  //   phoneArabic: "XXXXXXXXXX",
  //   termsAndConditions:
  //     "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old...",
  //   termsAndConditionsArabic:
  //     "خلافًا للاعتقاد الشائع، فإن Lorem Ipsum ليس مجرد نص عشوائي. لها جذور في قطعة من الأدب اللاتيني الكلاسيكي من 45 قبل الميلاد، مما يجعلها أكثر من 2000 عام...",
  // };
  const decimalPosition = localStorage.getItem("decimalPosition");
  const companyProfileData = useSelector(
    (state) => state?.companyProfileSlice?.userValue
  );
  // console.log("company profile data", companyProfileData);
  const [headerImage, setHeaderImage] = useState(null);

  useEffect(() => {
    if (companyProfileData?.logo) {
      const img = new Image();
      img.onload = () => setHeaderImage(companyProfileData.logo);
      img.onerror = () => setHeaderImage(null);
      img.src = companyProfileData.logo;
    }
  }, [companyProfileData?.logo]);
  const [TotalValues, setTotalValues] = useState({
    ttBeforeVat: 0,
    ttIncVat: 0,
  });

  const { currencyDetails } = useSelector((state) => state.mainDashBoardSlice);
  useEffect(() => {
    if (allData?.length > 0) {
      setTotalValues({
        ttBeforeVat: allData
          ?.reduce((total, item) => {
            const qty = typeof item.qty === "number" ? item.qty : 0;
            const unitPrice =
              typeof item.unitPrice === "number" ? item.unitPrice : 0;
            return total + qty * unitPrice;
          }, 0)
          ?.toFixed(decimalPosition),
        ttIncVat: allData
          ?.reduce((acc, row) => {
            if (row.includedPrice === false) {
              return acc + (row.lineTotal + row.taxAmt);
            } else {
              return acc + row.lineTotal;
            }
          }, 0.0)
          ?.toFixed(decimalPosition),
      });
    }
  }, [allData]);


  return (
    <div
      className="bilingual-invoice-container-temp-3"
      style={{
        height: "350mm",
        width: "250mm",
        padding: "6mm",
        boxSizing: "border-box",
        position: "relative",
        pageBreakAfter: "always",
      }}
    >
      {
        <div className="header-wrapper-temp-3">
          <div className="invoice-header-temp-3">
            <div className="logo-section-temp-3">
              <div className="logo-temp-2">
                {headerImage && (
                  <img
                    src={headerImage}
                    alt="Logo"
                    className="header-logo-temp-2"
                  />
                )}
              </div>
              <div className="order-id-temp-3">
                Order ID: {invoiceDetails?.name || ""}
              </div>
            </div>
            <div className="invoice-title-temp-3">
              <h1>INVOICE</h1>
              {/* <p>Invoice No # {invoiceDetails.invoiceNo}</p> */}
            </div>
          </div>

          <div className="invoice-details-temp-3">
            <div className="invoice-to-temp-3">
              <h3>Invoice To</h3>
              <p>{invoiceDetails?.customerName || ""}</p>
              <p>{invoiceDetails?.customerAddress || ""}</p>
              <p>Phone: {invoiceDetails?.customerContact || ""}</p>
              <p>Invoice Date: {invoiceDetails?.firstDate || ""}</p>
            </div>
            {
              <div className="invoice-to-arabic">
                <h3>لنا فواتير</h3>
                <p>{invoiceDetails?.companyNameArabic || ""}</p>
                <p>{invoiceDetails?.addressArabic || ""}</p>
                <p>هاتف: {invoiceDetails?.phoneArabic || ""}</p>
              </div>
            }
          </div>
        </div>
      }

      {items?.length > 0 && (
        <table className="invoice-table-temp-3">
          <thead>
          <tr>
              <th>Sl.No</th>
              <th>PRODUCT</th>
              {invoiceDetails?.printSection !==
                printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                printSection.deliveryNote && invoiceDetails?.printSection !== printSection.customerInvoice && invoiceDetails?.printSection !==
                printSection.vendorBill &&invoiceDetails?.printSection !==
                printSection.purchaseWPO &&invoiceDetails?.printSection !==
                printSection.purchaseWPO &&invoiceDetails?.printSection !==
                printSection.debitNote && <th>DESCRIPTION</th>}
              {invoiceDetails?.printSection ===
                printSection.customerInvoice || invoiceDetails?.printSection ===
                printSection.vendorBill && <th> ACCOUNT</th>}
              {invoiceDetails?.printSection !==
                printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                printSection.deliveryNote && printSection.deliveryNote && invoiceDetails?.printSection !==
                printSection.deliveryNote && <th>QTY</th>}
              <th>UOM</th>
              {invoiceDetails?.printSection ===
                printSection.deliveryNote && <th>DEMAND QUANTITY</th>}
              {invoiceDetails?.printSection ===
                printSection.deliveryNote && <th>DONE QUANTITY</th>}
              {invoiceDetails?.printSection ===
                printSection.goodsReceiveNote && <th>ORDER QUANTITY</th>}
              {invoiceDetails?.printSection ===
                printSection.goodsReceiveNote && <th>DELIVER QUANTITY</th>}
              {invoiceDetails?.printSection !==
                printSection.goodsReceiveNote && printSection.deliveryNote && invoiceDetails?.printSection !==
                printSection.deliveryNote && <th>RATE</th>}
              {invoiceDetails?.printSection !==
                printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                printSection.deliveryNote && invoiceDetails?.printSection !==
                printSection.customerInvoice && invoiceDetails?.printSection !==
                printSection.salesWSO && invoiceDetails?.printSection !==
                printSection.creditNote && invoiceDetails?.printSection !==
                printSection.vendorBill &&invoiceDetails?.printSection !==
                printSection.purchaseWPO &&invoiceDetails?.printSection !==
                printSection.debitNote &&  <th>AMOUNT</th>}
              {invoiceDetails?.printSection !==
                printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                printSection.deliveryNote && <th>DISCOUNT</th>}
              {invoiceDetails?.printSection !==
                printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                printSection.deliveryNote && invoiceDetails?.printSection !==
                printSection.customerInvoice && invoiceDetails?.printSection !==
                printSection.creditNote && invoiceDetails?.printSection !==
                printSection.purchaseWPO &&invoiceDetails?.printSection !==
                printSection.debitNote &&<th>VAT%</th>}
              {invoiceDetails?.printSection !==
                printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                printSection.deliveryNote && <th>VAT</th>}
              {invoiceDetails?.printSection !==
                printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                printSection.deliveryNote && <th>NET AMOUNT</th>}

            </tr>
          </thead>
          <tbody>
            {items?.length > 0 ? (
              <>
                {items.map((item, index) => (
                  <tr
                    key={index}
                    className={
                      index === items.length - 1
                        ? "invoice-table-btm-temp-1"
                        : ""
                    }
                  >
                    <td>{item?.id}</td>
                    <td>{item?.product}</td>

                    {invoiceDetails?.printSection !== printSection.goodsReceiveNote &&
                      invoiceDetails?.printSection !== printSection.deliveryNote &&
                      invoiceDetails?.printSection !== printSection.customerInvoice && invoiceDetails?.printSection !==
                      printSection.vendorBill &&invoiceDetails?.printSection !==
                      printSection.purchaseWPO &&invoiceDetails?.printSection !==
                      printSection.debitNote && 
                      <td>{item?.label}</td>}
                    {invoiceDetails?.printSection ===
                      printSection.customerInvoice || invoiceDetails?.printSection ===
                      printSection.vendorBill && (
                        <td>{item?.accountName}</td>
                      )}
                    {invoiceDetails?.printSection !==
                      printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                      printSection.deliveryNote && <td>{item?.qty}</td>}
                    <td>{item?.uomName}</td>
                    {invoiceDetails?.printSection ===
                      printSection.goodsReceiveNote && (
                        <td>{item?.orderQuantity}</td>
                      )}
                    {invoiceDetails?.printSection ===
                      printSection.goodsReceiveNote && (
                        <td>{item?.recievedQuantity}</td>
                      )}

                    {invoiceDetails?.printSection !==
                      printSection.goodsReceiveNote && printSection.deliveryNote && (
                        <td>{item.unitPrice?.toFixed(decimalPosition)}</td>
                      )}
                    {invoiceDetails?.printSection !==
                      printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                      printSection.customerInvoice && invoiceDetails?.printSection !==
                      printSection.salesWSO && invoiceDetails?.printSection !==
                      printSection.creditNote && invoiceDetails?.printSection !==
                      printSection.vendorBill &&invoiceDetails?.printSection !==
                      printSection.purchaseWPO &&invoiceDetails?.printSection !==
                      printSection.debitNote && (
                        <td>
                          {(item.qty * item.unitPrice)?.toFixed(decimalPosition)}
                        </td>
                      )}
                    {invoiceDetails?.printSection !==
                      printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                      printSection.deliveryNote && (
                        <td>{item?.discount}%</td>
                      )}
                    {invoiceDetails?.printSection !==
                      printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                      printSection.deliveryNote && invoiceDetails?.printSection !==
                      printSection.customerInvoice && invoiceDetails?.printSection !==
                      printSection.creditNote && invoiceDetails?.printSection !==
                      printSection.purchaseWPO &&invoiceDetails?.printSection !==
                      printSection.debitNote && (
                        <td>
                          {item?.taxes?.map((r, i) => (
                            <p
                              key={i}
                              className="tax"
                              style={{ margin: "1px", border: "none" }}
                            >
                              {r?.amount}%
                            </p>
                          ))}
                        </td>
                      )}
                    {invoiceDetails?.printSection !==
                      printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                      printSection.deliveryNote && (
                        <td>{item.taxAmt?.toFixed(decimalPosition)}</td>
                      )}
                    {invoiceDetails?.printSection !==
                      printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                      printSection.deliveryNote && (
                        <td>
                          {item?.includedPrice === false
                            ? (item.lineTotal + item.taxAmt)?.toFixed(
                              decimalPosition
                            )
                            : item.lineTotal?.toFixed(decimalPosition)}
                        </td>
                      )}
                  </tr>
                ))}

                {invoiceDetails?.printSection !==
                  printSection.deliveryNote && invoiceDetails?.printSection !==
                  printSection.customerInvoice &&invoiceDetails?.printSection !==
                  printSection.vendorBill&& tableTotal && (
                    <tr className="table-tt-temp-1">
                      <td colSpan={
                        invoiceDetails?.printSection === printSection.goodsReceiveNote
                          ? 3
                          : invoiceDetails?.printSection === printSection.salesWSO ||invoiceDetails?.printSection === printSection.purchaseWPO ||invoiceDetails?.printSection === printSection.debitNote
                            ? 5
                            : 6
                      }>
                        Total
                      </td>

                      {invoiceDetails?.printSection !==
                        printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                        printSection.deliveryNote && invoiceDetails?.printSection !==
                        printSection.creditNote && invoiceDetails?.printSection !==
                        printSection.purchaseWPO&&invoiceDetails?.printSection !==
                        printSection.debitNote &&(
                          <td>
                            {currencyDetails?.symbol}
                            {TotalValues?.ttBeforeVat || "0.00"}
                          </td>
                        )}
                      {invoiceDetails?.printSection !==
                        printSection.goodsReceiveNote && <td colSpan={2}></td>}
                      {invoiceDetails?.printSection !==
                        printSection.goodsReceiveNote && invoiceDetails?.printSection !==
                        printSection.creditNote && invoiceDetails?.printSection !==
                        printSection.purchaseWPO&&invoiceDetails?.printSection !==
                        printSection.debitNote && (
                          <td>
                            {" "}
                            {allData
                              ?.reduce((acc, row) => acc + row?.taxAmt, 0.0)
                              ?.toFixed(decimalPosition) || "0.00"}
                          </td>
                        )}
                      {invoiceDetails?.printSection !==
                        printSection.goodsReceiveNote &&(
                          <td>
                            {currencyDetails?.symbol}
                            {TotalValues?.ttIncVat || "0.00"}
                          </td>
                        )}
                      {invoiceDetails?.printSection ===
                        printSection.goodsReceiveNote && (
                          <td>{invoiceDetails?.totalReceivedQty || ""}</td>
                        )}
                      {invoiceDetails?.printSection ===
                        printSection.goodsReceiveNote && (
                          <td>{invoiceDetails?.totalReceivedQty || ""}</td>
                        )}
                    </tr>
                  )}
              </>
            ) : (
              <tr className="no-data-bt-temp-1">
                <td colSpan={11}>No Data</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {isLastPage && (
        <div className="last-tt-page-temp-3" style={{ marginTop: "15.5em" }}>
          {/* <div className="authorized-signatory-temp-3">
            <p>Authorized Signatory</p>
            <div className="signature-line-temp-3"></div>
          </div> */}
          <div className="authorized-signatory-temp-2">
            <p>
              <span>AUTHORIZED SIGNATORY FOR</span>
            </p>
            <div className="signature-line-temp-2"></div>
          </div>

          <div className="terms-conditions-temp-3">
            <h4>Terms and conditions :</h4>
            {/* <p>{invoiceDetails.termsAndConditions}</p> */}
          </div>

          <div className="terms-conditions-arabic-temp-3">
            <h4>الشروط والأحكام:</h4>
            {/* <p>{invoiceDetails.termsAndConditionsArabic}</p> */}
          </div>

          <div className="invoice-footer-temp-3">
            <p>Thank you for your Business</p>
          </div>
        </div>
      )}
      <footer
        style={{
          position: "absolute",
          width: "100%",
          padding: "0 1em ",
          right: "20mm",
        }}
      >
        <TempFooter
          template={3}
          totalPage={totalPages}
          currentPage={pageNumber}
          companyDetails={{
            phoneNumber: companyProfileData?.contactNumber,
            email: companyProfileData?.companyEmail,
            website: companyProfileData?.website,
          }}
        />
      </footer>
    </div>
  );
};

export default PrintTempThree;
